import React, { useRef, useEffect } from 'react'
import * as THREE from 'three'

// Accept props: scene (the actual THREE.Object3D), meshGroups (calculated in App), visibilityState, modelPosition
const Model = ({ scene, meshGroups, visibilityState, modelPosition }) => {
  const modelRef = useRef();

  // --- Initial Fade-In Animation is now handled in App.jsx via the main timeline --- 

  // --- Apply Visibility based on State from App.jsx ---
  useEffect(() => {
    // console.log("Model - Applying visibility state:", visibilityState); // Reduce console noise
    if (!meshGroups || Object.keys(visibilityState).length === 0) {
        // console.log("Model - Waiting for meshGroups or visibilityState");
        return; 
    }

    Object.entries(meshGroups).forEach(([groupName, meshes]) => {
        const isVisible = visibilityState[groupName];
        if (isVisible !== undefined) {
            // Apply visibility to all meshes in the group
            meshes.forEach(mesh => {
                mesh.visible = isVisible;
            });
        } else {
            // This case should ideally not happen if initialization is correct
            console.warn(`Model - Visibility state for group "${groupName}" is missing.`);
        }
    });

  }, [meshGroups, visibilityState]); 

  // Return the primitive scene object passed down from App
  return <primitive 
            ref={modelRef} 
            object={scene} 
            scale={7} 
            position={modelPosition}
         />;
}

// No need to preload here anymore

export default Model; 